import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { COLLAB_OPTIONS, collabTitleKey } from '../onboarding-options';
import type { OnboardingSnapshot } from '../onboarding-snapshot';
import { PanelCard } from './PanelCard';
import type { PanelCardState } from './panel-state';

/** The collaborations picked on step 2, as chips. */
export const CollabsPanelCard = ({
  snapshot,
  state,
}: {
  snapshot: OnboardingSnapshot;
  state: PanelCardState;
}) => {
  const { t } = useTranslation();
  const picked = COLLAB_OPTIONS.filter((option) =>
    snapshot.collaborationTypes.includes(option.value)
  );

  return (
    <PanelCard state={state}>
      <Flex align="baseline" justify="space-between" gap="8px">
        <Text fontFamily="heading" fontSize="13px" fontWeight="600" color="ink">
          {t('onboarding.brandPanel.collabs.label')}
        </Text>
        {picked.length > 0 && (
          <Text fontSize="12px" color="inkMuted">
            {t('onboarding.brandPanel.collabs.count', { count: picked.length })}
          </Text>
        )}
      </Flex>

      {picked.length > 0 ? (
        <Flex wrap="wrap" gap="6px" mt="10px">
          {picked.map(({ value, icon: Icon }) => (
            <Flex
              key={value}
              align="center"
              gap="6px"
              h="28px"
              px="8px"
              borderRadius="6px"
              bg="softCream"
              fontSize="12.5px"
              color="ink"
            >
              <Icon width={14} height={14} aria-hidden />
              {t(collabTitleKey(value))}
            </Flex>
          ))}
        </Flex>
      ) : (
        <Text fontSize="12.5px" color="inkSubtle" mt="6px">
          {t('onboarding.brandPanel.collabs.empty')}
        </Text>
      )}
    </PanelCard>
  );
};
